import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import AdminLogin from "./AdminLogin";

const TopBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutModalOpen, setAboutModalOpen] = useState(false);
  const [adminLoginOpen, setAdminLoginOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(
    sessionStorage.getItem("adminAuth") === "true"
  );

  const menuOptions = [
    "Treatments",
    "Doctor's info",
    "About us",
    isAdminLoggedIn ? "Logout" : "Log in",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const handleAboutClick = () => {
    setMenuOpen(false);
    setAboutModalOpen(true);
  };

  const handleTreatmentsClick = () => {
    setMenuOpen(false);
    const expertiseSection = document.getElementById("expertise");
    if (expertiseSection) {
      expertiseSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleMeetClick = () => {
    setMenuOpen(false);
    const MeetSection = document.getElementById("meet");
    if (MeetSection) {
      MeetSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleAdminLoginSuccess = () => {
    sessionStorage.setItem("adminAuth", "true");
    setIsAdminLoggedIn(true);
    setAdminLoginOpen(false);
    navigate("/admin", { replace: true });
  };

  const handleAdminLogout = () => {
    sessionStorage.removeItem("adminAuth");
    setIsAdminLoggedIn(false);
    navigate("/", { replace: true });
  };

  return (
    <>
      <header className="topbar">
        <div className="topbar-left">
          MON-SAT:<br />
          10 a.m - 8 p.m
        </div>

        <div className="menu-container" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="menu-button"
          >
            <div></div>
            <div></div>
            <div></div>
          </button>

          {menuOpen && (
            <nav className="menu-dropdown">
              {menuOptions.map((option, i) => (
                <div
                  key={i}
                  className="menu-option"
                  onClick={() => {
                    if (option === "About us") {
                      handleAboutClick();
                    } else if (option === "Treatments") {
                      handleTreatmentsClick();
                    } else if (option === "Doctor's info") {
                      handleMeetClick();
                    } else if (option === "Log in") {
                      setAdminLoginOpen(true);
                    } else if (option === "Logout") {
                      handleAdminLogout();
                    } else {
                      setMenuOpen(false);
                    }
                  }}
                >
                  {option}
                </div>
              ))}
            </nav>
          )}
        </div>
      </header>

      <Modal
        isOpen={aboutModalOpen}
        onClose={() => setAboutModalOpen(false)}
        title="About Us"
      />

      {adminLoginOpen && (
        <AdminLogin
          onClose={() => setAdminLoginOpen(false)}
          onLoginSuccess={handleAdminLoginSuccess}
        />
      )}
    </>
  );
};
export default TopBar;